import React, { FC } from 'react';

import styled, { css } from 'styled-components/macro';

import media from 'helpers/media';

type GridProps = {
    alignCenter?: boolean;
    alignRight?: boolean;
    addBottomMargin?: boolean;
    alignItems?: 'center' | 'flex-end'; // other values of can be added here if needed
};

const Row = styled.div<GridProps>`
    display: flex;
    flex-wrap: wrap;
    margin-left: -${({ theme }) => theme.space.base};

    ${({ alignCenter }) =>
        alignCenter &&
        css`
            justify-content: center;
        `}

    ${({ alignRight }) =>
        alignRight &&
        css`
            justify-content: flex-end;
        `}


    ${({ theme }) => media.laptop`
        margin-left: -${theme.space.medium};
    `}

    ${({ theme }) => media.desktop`
        margin-left: -${theme.space.medium};
    `}

    ${({ theme, addBottomMargin }) =>
        addBottomMargin &&
        css`
            margin-bottom: ${theme.space.xlarge};
        `}


    ${({ alignItems }) =>
        alignItems &&
        css`
            align-items: ${alignItems};
        `}
`;

const Grid: FC<GridProps & React.HTMLAttributes<HTMLDivElement>> = ({
    alignRight,
    alignCenter,
    addBottomMargin,
    alignItems,
    ...rest
}) => {
    return (
        <Row
            addBottomMargin={addBottomMargin}
            alignRight={alignRight}
            alignCenter={alignCenter}
            alignItems={alignItems}
            {...rest}
        >
            {rest.children}
        </Row>
    );
};

export default Grid;
